import { ForwardedRef } from 'react';
import * as React from 'react';

import cx from 'classnames';
import { Column } from 'react-table';

import { WorkspaceMember } from '../../../../../api/workspaces/getWorkspaceMembers';

interface Props {
  children: React.ReactNode;
  column: Column<WorkspaceMember>;
  header?: boolean;
  onClick?: () => void;
}
export const WorkspaceMembersTableCell = React.forwardRef(
  function WorkspaceMembersTableCell(
    { children, column, header, onClick }: Props,
    ref: ForwardedRef<HTMLDivElement>
  ) {
    const cellCx = cx(
      'flex items-center antialiased flex-grow flex-1 truncate',
      'text-left',
      !header && 'text-base text-blue-900 ',
      column.id === 'email' && 'hidden sm:flex',
      column.id === 'access' && 'justify-end',
      header &&
        'text-xs font-700 leading-8 text-cyan-700 tracking-wider uppercase select-none flex flex-row'
    );
    return (
      <div ref={ref} className={cellCx} onClick={onClick}>
        {header ? (
          children
        ) : (
          <span
            className={cx(
              column.id === 'fullName' && 'truncate',
              column.id === 'email' && 'truncate',
              'block'
            )}
          >
            {children}
          </span>
        )}
      </div>
    );
  }
);
